import { modulePermissionsSelectors } from '@va/dashboard/selectors/core';
import { LoaderBar } from '@va/ui/design-system';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route, useHistory } from 'react-router-dom';
import Layout from '../layout/Layout';

type WebsiteRouteProps = {
  component: any;
  hasBackButton?: boolean;
  extraProps?: Record<string, any>;
  exact?: boolean;
  path: string;
  moduleName?: string;
};
export const WebsiteRoute = ({
  component: Component,
  hasBackButton,
  extraProps,
  moduleName,
  ...rest
}: WebsiteRouteProps) => {
  const history = useHistory();
  const isEnabled = useSelector(modulePermissionsSelectors.isModuleEnabled);

  if (!isEnabled(moduleName ?? '')) {
    history.push('/');
    return;
  }
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout hasBackButton={hasBackButton}>
          <Suspense fallback={<LoaderBar />}>
            <Component {...props} {...extraProps} />
          </Suspense>
        </Layout>
      )}
    />
  );
};

export default WebsiteRoute;
